import { v4 as uuidv4 } from 'uuid';
import { Injectable} from '@angular/core';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Note } from '../models/note';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class NotesService {

  baseUrl = environment.apiEndpoint + '/notes/';

  private messageSource = new BehaviorSubject<string>('');
  currentMessage = this.messageSource.asObservable();

  constructor(private http: HttpClient) {  }

  getProjectNotes(projectId: string) {
    return this.http.get<Note[]>(this.baseUrl + projectId);
  }

  getBidNotes(bidId: string) {
    return this.http.get<Note[]>(this.baseUrl + 'bid/' + bidId);
  }

  getVendorNotesInProject(projectId: string, vendorId: string) {
    return this.http.get<Note[]>(this.baseUrl + projectId + '/vendor/' + vendorId);
  }

  getClientNotesInProject(projectId: string, clientId: string) {
    return this.http.get<Note[]>(this.baseUrl + projectId + '/client/' + clientId);
  }

  getClientNotes(clientId: string) {
    return this.http.get<Note[]>(this.baseUrl + 'client/' + clientId);
  }

  getVendorNotes(vendorId: string) {
    return this.http.get<Note[]>(this.baseUrl + 'vendor/' + vendorId);
  }

  getProjectNotesForSummary(bidNumber: string) {
    return this.http.get<Note[]>(this.baseUrl + 'summary/' + encodeURI(bidNumber));
  }

  getScreeningCriteria(projectId: string) {
    return this.http.get<Note[]>(this.baseUrl + 'screening/' + projectId);
  }

  addNote(note: Note) {
    return this.http.post<Note>(this.baseUrl, note);
  }

  editNote(model: any): Observable<any> {
    return this.http.put(this.baseUrl  + model.id, model);
  }

  deleteNote(id: string) {
    return this.http.delete(this.baseUrl + id);
  }

  getAttachmentDownloadUrl(noteId: string, attachmentId: string): Observable<string> {
    return this.http.get(this.baseUrl + noteId + '/attachments/' + attachmentId + '/download', { responseType: 'text' });
  }

  addNoteReply(note: any) {
    return this.http.post<any>(this.baseUrl + 'reply', note);
  }

  editNoteReply(model: any): Observable<any> {
    return this.http.put(this.baseUrl + 'reply/'  + model.id, model);
  }

  deleteNoteReply(id: string) {
    return this.http.delete(this.baseUrl + 'reply/' + id);
  }

  vendorNoteEmailNotification(projectId: string, data: { from: string; to: string[]; subject: string; body: string; vendorName: string }): Observable<any> {
    return this.http.post(this.baseUrl + 'vendorEmailNotification/' + projectId, data);
  }

  addNoteReaction(noteType: 'note' | 'reply', noteId: string, reactionType: string) {
    return this.http.put(this.baseUrl + noteType + '/' + noteId + '/reaction/' + reactionType, {});
  }

  removeNoteReaction(noteType: 'note' | 'reply', noteId: string, reactionType: string) {
    return this.http.delete(this.baseUrl + noteType + '/' + noteId + '/reaction/' + reactionType, {});
  }
}
